export default "__VITE_ASSET__C_cRdw5W__";